import axiosInstance from "./AxiosInstance";
//const token = "e532c7ba3d7dd872df0f67576c161969";

// Create a new note
export const createNote = async (noteData) => {
  return axiosInstance.post("/admin/addNote", noteData);
};

// Get all notes
export const getNotes = async (patient_id, pagination, pageid) => {
  return axiosInstance.post(
    '/admin/noteList',
    { patient_id, pagination, pageid  }
  );
};

export function sendDoctorNoteReply(note_id, reply) {
  return axiosInstance.post("/servicecaller/doctorNoteReply", {
    note_id,
    reply,
  });
}


export function formatNotes(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map(note => ({
      ...note,
      note_id: note.note_id || note._id || note.id,
    }));
  }

  let notes = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      notes.push({
        ...responseData[key],
        note_id: responseData[key].note_id || responseData[key]._id || responseData[key].id || key,
      });
    }
  }
  console.log("formatedNotes:",notes);
  return notes;
}
